import React from "react";
import { Link, NavLink } from "react-router-dom";
const Permission = () => {
  const userPermission = [
    {
      PermissionName: "Merchant's permissions - ",
      role: "Can access and manage all merchants.",
    },
    {
      PermissionName: "Customer's permissions - ",
      role: "Can access, create, manage and blacklist customers",
    },
    {
      PermissionName: "Balances permissions - ",
      role: "Can access balance, settlement and top up wallet",
    },
    {
      PermissionName: "Transfers permissions - ",
      role: "Can access, create, approve transfers and manage beneficiaries",
    },
    {
      PermissionName: "Subaccounts Permissions - ",
      role: "Can access, create and edit subaccounts",
    },
    {
      PermissionName: "Cards permissions - ",
      role: "Can access, create, edit and delete card",
    },
    {
      PermissionName: "Chargebacks permissions - ",
      role: "Can access, create and edit chargebacks",
    },
    {
      PermissionName: "Transactions permissions - ",
      role: "Can view transactions, refund and log refunds",
    },
    {
      PermissionName: "Registeration permissions - ",
      role: "Can view transactions, refund and log refunds",
    },
  ];
  return (
    <div className="">
      <h1 className="text-2xl font-bold pb-4">
        Configurations - User Permission
      </h1>
      <div className="bg-white h-[924px] py-5 px-[4rem] rounded-md">
        <section className="flex justify-between px-5 items-center border rounded-t-md w-full p-3">
          <div className="text-orange-400 text-[20px] font-semibold">
            Add user Permission
          </div>
          <div>
            <svg
              width="12"
              height="6"
              viewBox="0 0 12 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 0.75L6 5.25L10.5 0.75"
                stroke="#464255"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </section>
        <section className="flex justify-between">
          <div className="p-5 w-[60%] gap-5 flex flex-col">
            <p className="text-2xl font-medium">Permission details</p>
            <p className="text-sm font-normal py-">
              Enter a name for this card scheme and a few required inputs. You
              can <br /> make changes to this much later.
            </p>
            <div className="flex flex-col gap-2 ">
              <label htmlFor="scheme" className="text-[16px]">
                Name of Permission
              </label>
              <input
                className="h-[50px] bg-gray-200 w-[80%] rounded-md p-4"
                name="scheme"
                placeholder="Example:Chief of staff"
                type="text"
              />
            </div>
            <div className="flex flex-col gap-2 ">
              <label htmlFor="shortname" className="text-[16px]">
                Permission description
              </label>
              <input
                className="h-[154px] bg-gray-200 w-[80%] rounded-md p-4"
                name="shortname"
                type="text"
              />
            </div>
            <div className="w-[40%] bg-orange-500 text-white flex justify-center p-2 rounded-md">
              Save Permission
            </div>
          </div>
          <div className="w-[40%] border-b bg-white">
            <div className="border-b pb-4">
              <div className="text-[24px] font-medium">Permissions</div>
            </div>
            {userPermission.map((r) => (
              <div className="flex gap-3 border-b p-5 h-[5rem]">
                <div className="text-[14px]">
                  <span className="font-bold">{r.PermissionName}</span>
                  {r.role}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Permission;
